export default "__VITE_ASSET__Dj7OiKcw__"